<template>
  <div class="promotion">
    <div class="promotion-content">
      <Header />

      <div class="partner">
        <div class="partner-wrap">
          <div class="partner-title">
            <img src="@assets/promotion/phone.png" alt="" />
            联系我们
          </div>
          <div class="partner-box">
            <div class="phone-item">
              <div>电话：</div>
              <div>020-22330962</div>
            </div>
            <div class="phone-item">
              <div>邮箱：</div>
              <div>elieen.lee@vipshop.com</div>
            </div>
          </div>
        </div>

        <div class="partner-wrap">
          <div class="partner-title">
            <img src="@assets/promotion/wechat_co.png" alt="" />
            企业微信
          </div>
          <div class="partner-box">
            <img class="qr-code" src="@assets/promotion-h5/qr-code.png" alt="" />
          </div>
        </div>

        <div class="partner-wrap">
          <div class="partner-title">
            <img src="@assets/promotion/consult.png" alt="" />
            预约咨询
          </div>
          <div class="partner-box">
            <div class="contact-wrap">
              <div class="contact-item">
                <div>公司名</div>
                <input class="input-text" v-model="applyName" placeholder="请输入您的公司名" type="text">
              </div>
              <div class="contact-item">
                <div>手机号</div>
                <input class="input-text" v-model="applyPhone" placeholder="请输入您的手机号" type="number">
              </div>
              <div class="contact-tip" :class="{'visible': showTip}">{{showTip}}</div>
              <div class="contact-btn" @click="handleBook">预约咨询</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SuccessDialog :visible.sync="isShowDialog" />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/PromotionHeader.vue'
import Footer from '@/components/PromotionFooter.vue'
import SuccessDialog from '@/components/SuccessDialog.vue'
import util from '@/utils'
import api from '@/lib/api'
import {encrypt} from '@/lib/encryptor'

export default {
  name: 'promotion-business',
  components: {
    Header,
    Footer,
    SuccessDialog
  },
  data() {
    return {
      applyName: '',
      applyPhone: '',
      showTip: '',
      isShowDialog: false,
    }
  },
  created() {
    util.setPCHtmlFontSize()

    this.$tracker.page('wdg_page_official_website', {
      page_id: 3 // contact us 联系我们
    })
  },
  methods: {
    handleBook() {
      if (!this.applyName) {
        this.showTip = '请填入您的公司名'
        return
      }
      if (!this.applyPhone) {
        this.showTip = '请填入您的手机号'
        return
      }
      if (!util.validate('mobile', this.applyPhone)) {
        this.showTip = '手机号格式不正确'
				return
			}
      let data = {
        applyName: encrypt(this.applyName),
        applyPhone: encrypt(this.applyPhone),
      }
      api.applyChannel(data).then(() => {
        this.isShowDialog = true
        this.applyName = ''
        this.applyPhone = ''
      }).catch(err => {
        // util.toast(err.msg || err.message)
      })
    },
  }
}
</script>

<style lang="stylus" scoped>
.promotion {
  width: 100%;
  min-width: 1000px;
  background: #fff;
  font-family: PingFangSC-Regular, PingFang SC;

  .promotion-content {
    min-height: calc(100vh - 80rem);
  }

  .partner {
    display: flex;
    justify-content: center;
    margin-top: 80rem;

    .partner-wrap {
      height: 400rem;
      background: #F90080;
      box-shadow: 0px 0px 16rem 0px rgba(0,0,0,0.2000);
      border-radius: 20rem;
      padding: 20rem 10rem 10rem;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 40rem;
      &:last-child {
        margin-right: 0;
      }

      .partner-title {
        display: flex;
        align-items: center;
        font-size: 30rem;
        color: #fff;
        img {
          width: 45rem;
          height: 45rem;
          margin-right: 10rem;
        }
      }
      .partner-box {
        // width: 275rem;
        height: 300rem;
        border-radius: 20rem;
        background: #fff;
        box-shadow: 0px 0px 16rem 0px rgba(0,0,0,0.2000);
        padding: 20rem;
        box-sizing: border-box;

        .phone-item {
          color: #000;
          font-size: 24rem;
          line-height: 33rem;
          padding-top: 10rem;
          padding-right: 10rem;
        }

        .qr-code {
          width: 270rem;
          height: 270rem;
        }

        .contact-wrap {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: space-between;
          // width: 360rem;
          padding: 10rem;
          cursor: unset;

          .contact-item {
            display: flex;
            align-items: center;
            font-size: 24rem;
            color: #000;
            font-weight: bold;
            margin-bottom: 15rem;
            div {
              flex-shrink: 0;
            }
            .input-text {
              width: 280rem;
              height: 50rem;
              line-height: 50rem;
              margin-left: 10rem;
              border: 1px solid #979797;
              border-radius: 10rem
              color: #000;
              font-size: 22rem;
              outline-style: none;
              padding: 0 10rem;
              box-sizing: border-box;
              font-weight: normal;
              &::placeholder {
                color: #A3A3A3;
                font-weight: normal;
              }
            }
          }
          .contact-tip {
            height: 30rem;
            color: #999;
            font-size: 18rem;
            font-weight: 300;
            margin-left: 80rem;
            visibility: hidden;
            text-align: left;
          }
          .visible {
            visibility: visible;
          }
          .contact-btn {
            margin-top: 30rem;
            width: 100%;
            height: 50rem;
            line-height: 50rem;
            background: #F90080;
            border-radius: 25rem;
            color: #fff;
            font-size: 26rem;
            text-align: center;
            cursor: pointer;
          }
          input[type=number] {
            -moz-appearance:textfield;
          }
          input[type=number]::-webkit-inner-spin-button,
          input[type=number]::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/promotion-business.vue